import { StyleSheet, View } from 'react-native'
import { Text, useTheme } from 'react-native-paper'
import { useClearJobsFilters, useHasActiveJobsFilters } from '@/stores/jobs-filter-store'
import { Button } from '@/ui/Button'
import { EmptyCard } from '@/ui/EmptyCard'

interface JobsEmptyStateProps {
    hasAnyJobs: boolean
    onAddJob: () => void
}

export function JobsEmptyState({ hasAnyJobs, onAddJob }: JobsEmptyStateProps) {
    const theme = useTheme()
    const hasActiveFilters = useHasActiveJobsFilters()
    const clearFilters = useClearJobsFilters()

    if (!hasAnyJobs) {
        return (
            <EmptyCard
                icon="briefcase"
                title="No jobs yet"
                subtitle="Add jobs to track work progress and manage customer assignments"
                buttonLabel="Add Job"
                onButtonPress={onAddJob}
            />
        )
    }

    if (hasActiveFilters) {
        return (
            <View style={styles.container}>
                <Text variant="bodyLarge" style={{ color: theme.colors.onSurfaceVariant }}>
                    No matches
                </Text>
                <Text variant="bodyMedium" style={{ color: theme.colors.onSurfaceVariant }}>
                    Try adjusting your search or filters
                </Text>
                <Button
                    title="Show All"
                    mode="outlined"
                    onPress={clearFilters}
                    style={styles.button}
                />
            </View>
        )
    }

    return null
}

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
        justifyContent: 'center',
        paddingVertical: 48,
        gap: 8,
    },
    button: {
        marginTop: 8,
    },
})
